enum ConversationStatusType {
    Active,
    Closed,
}

export default ConversationStatusType;
